"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ScenarioStatisticShortcut_1 = require("./ScenarioStatisticShortcut");

exports.ScenarioStatisticShortcut = ScenarioStatisticShortcut_1.ScenarioStatisticShortcut;

var ScenarioStatisticTarget_1 = require("./ScenarioStatisticTarget");

exports.ScenarioStatisticTarget = ScenarioStatisticTarget_1.ScenarioStatisticTarget; // @endindex
// @index('./*', pp => `import * as ${pp.name} from '${pp.path}';`, { "ignore": ["./*.ts", "./*.md"] })

var shortcuts = require("./shortcuts");

exports.shortcuts = shortcuts;